export const SIZE = {
    TINY: 'tiny',
    SMALL: 'small',
    MEDIUM: 'medium',
};
export const SKIN = {
    LIGHT: 'light',
    NEUTRAL: 'neutral',
};
//# sourceMappingURL=VerticalTabs.constants.js.map